<template>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-users mr-2" style="color: #30a322;"></i>Referral Program
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <!-- Hero text -->
        <div class="text-center mb-4">
          <h5>Refer friends &amp; earn rewards together!</h5>
          <p class="text-muted">Both you and your referral earn milestone rewards as they play.</p>
        </div>

        <!-- Referral link (only when prop is set, i.e. logged-in user) -->
        <div v-if="referralLink" class="card mb-4" style="border-left: 3px solid #30a322;">
          <label class="small text-muted mb-1">Your Referral Link</label>
          <div class="input-group">
            <input type="text" class="form-control mb-0" :value="referralLink" readonly />
            <button class="btn" @click="copyLink" type="button">
              <i class="fas fa-copy mr-1"></i>{{ copied ? 'Copied!' : 'Copy' }}
            </button>
          </div>
        </div>

        <!-- How it works (3 steps) -->
        <div class="row text-center mb-4 g-3">
          <div class="col-4">
            <i class="fas fa-link fa-2x mb-2" style="color: #30a322;"></i>
            <p class="small mb-0"><strong>1. Share</strong><br>Send your referral link</p>
          </div>
          <div class="col-4">
            <i class="fas fa-gamepad fa-2x mb-2" style="color: #30a322;"></i>
            <p class="small mb-0"><strong>2. Play</strong><br>They sign up &amp; play</p>
          </div>
          <div class="col-4">
            <i class="fas fa-gift fa-2x mb-2" style="color: #30a322;"></i>
            <p class="small mb-0"><strong>3. Earn</strong><br>Both earn rewards!</p>
          </div>
        </div>

        <!-- Milestone rewards by type -->
        <h6 class="mb-3">Milestone Rewards</h6>
        <div v-for="group in milestoneGroups" :key="group.type" class="mb-3">
          <div class="d-flex align-items-center mb-2">
            <i :class="iconForType(group.type)" class="mr-2" style="color: #30a322;"></i>
            <strong>{{ formatType(group.type) }}</strong>
          </div>
          <div class="row g-2">
            <div class="col-6 col-md-4" v-for="ms in group.milestones" :key="ms.id">
              <div class="card text-center p-2" style="background: rgba(48,163,34,0.06);">
                <small class="text-muted">Tier {{ toRoman(ms.tier) }}</small>
                <p class="mb-0 small"><strong>{{ ms.description }}</strong></p>
                <small style="color: #30a322;"><i class="fas fa-gift mr-1"></i>{{ ms.rewardDescription }}</small>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA button for non-logged-in (Welcome page) -->
        <div v-if="!referralLink" class="text-center mt-3">
          <router-link to="/login" class="btn green" data-bs-dismiss="modal">
            <i class="fas fa-sign-in-alt mr-2"></i>Login
          </router-link>
        </div>

        <!-- CTA for logged-in (Account page) -->
        <div v-else class="text-center mt-3">
          <router-link to="/account/referrals" class="btn green" @click="$emit('close')">
            <i class="fas fa-users mr-2"></i>View My Referrals
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIClient from "@/services/APIClient.js";

export default {
  props: {
    referralLink: { type: String, default: '' },
  },
  data() {
    return {
      milestones: [],
      copied: false,
    };
  },
  computed: {
    milestoneGroups() {
      const types = ['VOTE', 'PLAY_TIME', 'SPEND'];
      return types.map(type => ({
        type,
        milestones: this.milestones.filter(m => m.type === type).sort((a, b) => a.tier - b.tier),
      })).filter(g => g.milestones.length > 0);
    },
  },
  created() {
    this.apiClient = new APIClient();
    this.fetchMilestones();
  },
  methods: {
    fetchMilestones() {
      this.apiClient.getReferralMilestones().then(r => {
        if (r.status === 200 && r.data) this.milestones = r.data;
      }).catch(() => {});
    },
    iconForType(type) {
      switch (type) {
        case 'VOTE': return 'fas fa-vote-yea';
        case 'PLAY_TIME': return 'fas fa-clock';
        case 'SPEND': return 'fas fa-coins';
        default: return 'fas fa-star';
      }
    },
    formatType(type) {
      switch (type) {
        case 'VOTE': return 'Vote';
        case 'PLAY_TIME': return 'PlayTime';
        case 'SPEND': return 'Spend';
        default: return type;
      }
    },
    toRoman(num) {
      const numerals = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
      return numerals[num] || String(num);
    },
    copyLink() {
      navigator.clipboard.writeText(this.referralLink);
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 2000);
    },
  },
};
</script>
